var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.2187C20.3322 13.2187 20.6068 13.4656 20.6502 13.7859L20.6562 13.875V15.8741L21.7316 15.844C22.0939 15.8339 22.3958 16.1193 22.406 16.4816C22.4153 16.8137 22.1762 17.0951 21.8572 17.1475L21.7684 17.156L20.0182 17.205C19.9336 17.2073 19.8524 17.1936 19.7773 17.1665C19.6889 17.1346 19.6092 17.0842 19.5431 17.0201C19.4764 16.9554 19.4234 16.8767 19.3888 16.7885C19.3701 16.7408 19.3568 16.6904 19.3497 16.638C19.3466 16.615 19.3447 16.5911 19.344 16.5674L19.3437 16.549V13.875C19.3437 13.5126 19.6376 13.2187 20 13.2187Z",
    fill: "#4251DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 11.25C11.25 10.2835 12.0335 9.5 13 9.5H27C27.9665 9.5 28.75 10.2835 28.75 11.25V28.75C28.75 29.7165 27.9665 30.5 27 30.5H13C12.0335 30.5 11.25 29.7165 11.25 28.75V11.25ZM13.875 27C13.875 26.5167 14.2667 26.125 14.75 26.125H22.625C23.1082 26.125 23.5 26.5167 23.5 27C23.5 27.4832 23.1082 27.875 22.625 27.875H14.75C14.2667 27.875 13.875 27.4832 13.875 27ZM14.75 22.625C14.2667 22.625 13.875 23.0167 13.875 23.5C13.875 23.9832 14.2667 24.375 14.75 24.375H25.25C25.7332 24.375 26.125 23.9832 26.125 23.5C26.125 23.0167 25.7332 22.625 25.25 22.625H14.75ZM24.8125 16.0625C24.8125 18.7204 22.6579 20.875 20 20.875C17.3421 20.875 15.1875 18.7204 15.1875 16.0625C15.1875 13.4046 17.3421 11.25 20 11.25C22.6579 11.25 24.8125 13.4046 24.8125 16.0625Z",
    fill: "#4251DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory2);
export default __webpack_public_path__ + "static/media/history2.0c2d759d51fa3f9a00e47e3384c1d2a3.svg";
export { ForwardRef as ReactComponent };